import type { ComputedRef } from 'vue';

/**
 * Stable locale segment for URLs when `locale` is missing or empty.
 * Keep in sync with `i18n.defaultLocale` in nuxt.config.
 */
const DEFAULT_LOCALE_CODE = 'en';

/** Locale code safe for paths like `/${code}/...` */
export default function useSafeLocaleCode(): ComputedRef<string> {
  const { locale } = useI18n();

  return computed(() => {
    const code = locale.value;
    if (typeof code === 'string' && code.trim() !== '') {
      return code;
    }
    return DEFAULT_LOCALE_CODE;
  });
}
